import React, { useEffect } from "react";
// import PropTypes from "prop-types";
import clsx from "clsx";
import { useNavigate } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  NoData,
  ReviewComment,
  ReviewCommentPlaceHolder,
  SpinnerCustom,
} from "@components";
import {
  getAllReviewsUserAction,
  getMoreReviewsUserAction,
} from "@redux/modules/review/slices";
import { useWindowSize } from "@hooks";
import ReviewSvg from "@assets/svgs/reviews.svg";
import styles from "./styles/ReviewsPage.module.css";
import { formatNumberText } from "@helpers";

const placeholder = Array.from(Array(3).keys());

const ReviewsPage = () => {
  const { getAllReviewsUser } = useSelector((state) => state.review);
  const { reviews, processing, pagination, processingGetMore } =
    getAllReviewsUser;
  const totalReviews = pagination.TotalCount;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { width } = useWindowSize();

  useEffect(() => {
    dispatch(getAllReviewsUserAction());
  }, []);

  const handleSeeMore = () => {
    dispatch(getMoreReviewsUserAction());
  };

  const handleEdit = (courseId) => {
    navigate(`/course/${courseId}#edit-review`);
  };

  // render
  return (
    <Container className="pt-4">
      <h5>
        <i className="bi bi-star mr-2"></i>
        All Review
      </h5>
      <Row className="mt-4">
        {width >= 992 && (
          <Col sm={12} lg={5} className="mb-4">
            <img
              src={ReviewSvg}
              alt="Reading reviews"
              className={styles.imageReviews}
            />
          </Col>
        )}
        <Col>
          <div className="d-flex flex-wrap justify-content-between">
            <h5>
              My All Reviews{" "}
              {totalReviews !== 0 &&
                `(${formatNumberText(totalReviews, "review")})`}
            </h5>
          </div>

          <div
            className={clsx("d-flex flex-column mt-4", styles.commentContainer)}
          >
            {processing &&
              placeholder.map((val) => <ReviewCommentPlaceHolder key={val} />)}

            {reviews &&
              reviews?.length !== 0 &&
              reviews.map((review, index) => {
                const courseId = review.enrollment.courses?.id || "";
                return (
                  <ReviewComment
                    key={index}
                    {...review}
                    editable={true}
                    onEdit={() => handleEdit(courseId)}
                  />
                );
              })}

            {!processing && (!reviews || reviews?.length === 0) && (
              <NoData message="No review yet" className="p-0" />
            )}

            {!processing && pagination.HasNext && reviews?.length !== 0 && (
              <button
                className={styles.btnSeeMore}
                onClick={handleSeeMore}
                disabled={processingGetMore}
              >
                {processingGetMore ? <SpinnerCustom /> : "See More Reviews"}
              </button>
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

/* required: display name */
ReviewsPage.displayName = "ReviewsPage";

/* required: props types */
ReviewsPage.propTypes = {};

/* required: default props */
ReviewsPage.defaultProps = {};

export { ReviewsPage };
